/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

import { useSelection } from '@zendeskgarden/container-selection';
import React from 'react';
import PropTypes from 'prop-types';

const useButtonGroup = options => {
  const {
    selectedItem,
    focusedItem,
    getContainerProps,
    getItemProps
  } = useSelection(options);
  const getGroupProps = function (_temp) {
    let {
      role = 'group',
      ...other
    } = _temp === void 0 ? {} : _temp;
    return { ...getContainerProps(other),
      role: role === null ? undefined : role,
      'data-garden-container-id': 'containers.buttongroup',
      'data-garden-container-version': '1.0.1'
    };
  };
  const getButtonProps = _ref => {
    let {
      role = 'button',
      ...other
    } = _ref;
    return { ...getItemProps({
        selectedAriaKey: 'aria-pressed',
        ...other
      }),
      role: role === null ? undefined : role
    };
  };
  return {
    selectedItem,
    focusedItem,
    getGroupProps,
    getButtonProps
  };
};

const ButtonGroupContainer = _ref => {
  let {
    children,
    render = children,
    ...options
  } = _ref;
  return React.createElement(React.Fragment, null, render(useButtonGroup(options)));
};
ButtonGroupContainer.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func,
  focusedItem: PropTypes.any,
  selectedItem: PropTypes.any,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func
};

export { ButtonGroupContainer, useButtonGroup };
